// sessionStorage is scoped to a single browser tab. A page opened with
// window.open() (e.g. the Dashboard button in SupportDropDown.vue) starts
// a brand new tab with no sessionStorage, even though the user is already
// logged in elsewhere. router.js and acl.js both key off sessionStorage
// (accessToken / roles) and bounce straight to /pages/login when it's
// missing. localStorage already holds everything needed to rebuild it, so
// do that here - this file must be imported first in main.js, before the
// router/acl modules read sessionStorage.
if (!sessionStorage.accessToken) {
  try {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (Array.isArray(userInfo) && userInfo.length) {
      var accountKey = localStorage.getItem('userAccountKey');
      var entry = userInfo.find(function (u) {
        return u.account && u.account.accountKey === accountKey;
      }) || userInfo[0];

      if (entry && entry.token && entry.userRoles) {
        sessionStorage.accessToken = entry.token;
        sessionStorage.username = entry.userRoles.username;
        sessionStorage.roles = JSON.stringify(entry.userRoles);
      }
    }
  } catch (e) {
    // malformed/absent cache - fall through to the normal login flow
  }
}
